import React from 'react';
import {
    DiscoverEventCardProps,
    EXPERIMENT_SEARCH_CARD_MAP_DESKTOP,
    EXPERIMENT_SEARCH_CARD_MAP_MOBILE,
} from '../../components/DiscoverEventCard';

import classNames from 'classnames';
import { useServerEnrolledStatsigExperiment } from '../../context/experiments';
import {
    UrgencySignalEventCardExperiment,
    UrgencySignalEventCardExperimentValues,
} from '../../types';
import './SearchEventCardStyleSwitcher.scss';

export type SearchEventCardStylesSwitcherProps = DiscoverEventCardProps & {
    forceVariant?: 'desktop' | 'mobile';
};

export const SearchEventCardStyleSwitcher: React.FunctionComponent<
    SearchEventCardStylesSwitcherProps
> = ({ forceVariant, ...props }) => {
    const { MobileEventCard, DesktopEventCard } = useGetEventCardTypes();

    const showMobile = forceVariant !== 'desktop';
    const showDesktop = forceVariant !== 'mobile';
    const shouldHandleVisibility = !forceVariant;

    return (
        <>
            {showMobile && (
                <div
                    className={classNames(
                        'discover-search-mobile-card',
                        shouldHandleVisibility &&
                            'discover-search-mobile-card--hiddeable',
                    )}
                    key={`discover-mobile-event-card-${props.event.id}`}
                >
                    <MobileEventCard {...props} />
                </div>
            )}
            {showDesktop && (
                <div
                    className={classNames(
                        'discover-search-desktop-card',
                        shouldHandleVisibility &&
                            'discover-search-desktop-card--hiddeable',
                    )}
                    key={`discover-desktop-event-card-${props.event.id}`}
                >
                    <DesktopEventCard {...props} />
                </div>
            )}
        </>
    );
};

export function useGetUrgencySignalExperimentCardType() {
    const urgencySignalEventCardExperimentVariant =
        useServerEnrolledStatsigExperiment<UrgencySignalEventCardExperimentValues>(
            {
                name: UrgencySignalEventCardExperiment.name,
                paramName: UrgencySignalEventCardExperiment.paramName,
                defaultValue: UrgencySignalEventCardExperiment.values.control,
            },
        ).variant;

    return urgencySignalEventCardExperimentVariant;
}

function useGetEventCardTypes() {
    const variantType = useGetUrgencySignalExperimentCardType();

    const MobileEventCard = variantType
        ? EXPERIMENT_SEARCH_CARD_MAP_MOBILE[variantType]
        : EXPERIMENT_SEARCH_CARD_MAP_MOBILE[
              UrgencySignalEventCardExperimentValues.control
          ];
    const DesktopEventCard = variantType
        ? EXPERIMENT_SEARCH_CARD_MAP_DESKTOP[variantType]
        : EXPERIMENT_SEARCH_CARD_MAP_DESKTOP[
              UrgencySignalEventCardExperimentValues.control
          ];

    return {
        MobileEventCard: MobileEventCard,
        DesktopEventCard: DesktopEventCard,
    };
}
